module.exports = __webpack_public_path__ + "img/placeholder2.140973a6.png";